import React from "react";
import ObservedSection from "../../components/ObservedSection";
import CTAButton from "../../components/CTAButton";
import styles from "./MainMobile.module.css";

const Pricing = ({ onEnter, onLeave }) => {
    return (
        <div className={styles.product_details}>
            <div className={styles.product_title}>
                OTUS, Your Daily Vision Trainer
            </div>
            <p style={{ color: 'black', fontSize: 11, marginTop: 0, marginBottom: 0 }}>
                Manage eye fatigue and age-related vision changes with daily vision training.
            </p>
            <ul className={styles.product_benefits}>
                <li><b>8-lens eye training</b> for daily vision care</li>
                <li><b>Near & far focus support</b></li>
                <li><b>Open-view design</b> for everyday use</li>
            </ul>

            {/* Pricing */}

            <div className={styles.pricing}>
                <div>
                    <div className={styles.pricing_label} style={{ paddingTop: 8 }}>Retail Price</div>
                    <p className={styles.original_price} style={{ paddingTop: 4 }}>
                        S$ 453
                    </p>
                </div>
                <div>
                    <div className={styles.pricing_label}>Special Price</div>
                    <p className={styles.special_price}>
                        S$ 299 <span style={{ color: '#ff0000', fontSize: "14px", border: '1px solid #ff0000', borderRadius: 50, padding: "0px 7px" }}>34% SALE</span>
                    </p>
                </div>

                <div>
                    <div className={styles.pricing_label}>SPay Later</div>
                    <div style={{ display: 'flex', flexDirection: 'column', paddingBottom: '12px' }}>
                        <p className={styles.special_price}>S$ 49.8 <span style={{ fontWeight: 400 }}>x</span> 6 months</p>
                        <div className={styles.special_price_detail}>(Pay in 6 installments with Shopee sPay Later)</div>
                    </div>
                </div>
            </div>
            <div className={styles.pricing} style={{borderTop: '0px'}}>
                <div>
                    <div className={styles.pricing_label} style={{backgroundColor: '#EFEFEF'}}>Warranty</div>
                    <div style={{ display: 'flex', flexDirection: 'column', paddingBottom: "12px" }}>
                        <p className={styles.warranty}>1-Year Warranty</p>
                        <div style={{fontSize: "10px", color: "#828282"}}>(Free Repair Service Included)</div>
                    </div>
                    
                </div>
            </div>

            {/* CTA Button */}
            <ObservedSection
                onEnter={onEnter}
                onLeave={onLeave}
            >
                <CTAButton
                    className={styles.cta}
                    titleClass={styles.cta_title}
                    subtitleClass={styles.cta_sub}
                    iconClass={styles.cta_icon}
                />
            </ObservedSection>
        </div>
    )
}

export default Pricing